import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@base-app';
import { Sizes } from '@common/types';
import { UpdateTeamMemberModalProps } from './UpdateTeamMemberModal.types';
import { TEAMS_TRANSLATION } from '@modules/teams/constants';

import UpdateTeamMemberForm from '../UpdateTeamMemberForm/UpdateTeamMemberForm';

const UpdateTeamMemberModal: FC<UpdateTeamMemberModalProps> = ({ onChange, onClose, onUpdate, show, user }) => {
  const { t } = useTranslation(TEAMS_TRANSLATION);

  return (
    <Modal onClose={onClose} show={show} size={Sizes.LARGE} title={t('edit_team_member')}>
      <UpdateTeamMemberForm onChange={onChange} user={user} onUpdateForm={onUpdate} onClose={onClose} />
    </Modal>
  );
};

export default UpdateTeamMemberModal;
